export default "__VITE_ASSET__Cc0r57Oi__"